<template>
    <div>
        <el-row :gutter="30">
            <template v-if="formData.accountType == 2">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="accountIdName" label="证件类型:" :rules="[{required: true, message: '请输入证件类型'}]">    
                        <el-input v-model.trim="formData.accountIdName" size="medium" maxlength="100" placeholder="请输入证件类型"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="licenseNumber" label="证件号码:" :rules="[{required: true, message: '请输入证件号码'}]"> 
                        <el-input v-model.trim="formData.licenseNumber" size="medium" maxlength="100" placeholder="请输入证件号码"></el-input>
                    </el-form-item>
                </el-col>
            </template>
            <el-col v-else :xs="24" :sm="12" :xl="8">
                <el-form-item prop="licenseNumber" label="营业执照编号:" :rules="[{required: true, message: '请输入营业执照编号'}]">
                        <el-input v-model.trim="formData.licenseNumber" size="medium" maxlength="100" placeholder="请输入营业执照编号"></el-input>
                </el-form-item>
            </el-col>
        </el-row>        
		<template v-if="formData.accountType == 2">
			<el-row :gutter="30">
				<el-col :xs="24" :sm="12" :xl="8">
					<el-form-item prop="pic1" label="证件:" :rules="[{required: true, message: '请上传证件'}]" :show-message="formData.pic1 ? false : true">
						<image-upload 
							:url.sync="formData.pic1" 
							:urlFull.sync="formData.pic1" 
						>
						</image-upload>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="12" :xl="8">    
					<el-form-item prop="pic2" label=" " class="hide-required-asterisk" :rules="[{required: true, message: '请上传证件'}]" :show-message="formData.pic2 ? false : true">
						<image-upload 
							:url.sync="formData.pic2" 
							:urlFull.sync="formData.pic2" 
						>
						</image-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</template>
            <template v-else>
				<el-row :gutter="30" v-if="type ==1">
					<!-- <el-col :xs="24" :sm="12" :xl="8">
						<el-form-item  prop="businessType" label="企业类型" :rules="[{required: true, message: '请选择企业类型'}]" >
							<el-select v-model="formData.businessType" placeholder="请选择企业类型" size="small">
								<el-option :value="0" label="有限责任公司（自然人投资或控股）"></el-option>
								<el-option :value="1" label="股份有限公司"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="registeredAddress" label="注册地址:" :rules="[{required: true, message: '请输入注册地址'}]">
								<el-input v-model.trim="formData.registeredAddress" size="medium" maxlength="100" placeholder="请输入注册地址"></el-input>
						</el-form-item>
					</el-col> -->
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="isExclusive" label="是否独家" :rules="[{required: true, message: '请选择是否独家'}]">
							<el-radio-group v-model="formData.isExclusive" size="medium">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="signTime" label="签约时间" :rules="[{required: true, message: '请输入签约时间'}]">
							<el-date-picker v-model="formData.signTime" type="datetime" placeholder="请输入签约时间"
								value-format="yyyy-MM-dd HH:mm:ss" size="medium"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30" v-if="type ==1">
					<!-- <el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="registeredCapitalStr" label="注册资本">
							<el-input-number  v-model="formData.registeredCapitalStr" :precision="2"
								controls-position="right" :min="0" :max="100000" size="medium"
								placeholder="请填写注册资本" style="width: 92%;"></el-input-number>  万元
						</el-form-item>
					</el-col> -->
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="corporationName" label="法人代表姓名:" :rules="[{required: true, message: '请输入法人代表姓名'}]">
								<el-input v-model.trim="formData.corporationName" size="medium" maxlength="100" placeholder="请输入法人代表姓名"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="pic1" label="营业执照:" :rules="[{required: true, message: '请上传营业执照'}]" :show-message="formData.pic1 ? false : true">
							<image-upload 
								:url.sync="formData.pic1" 
								:urlFull.sync="formData.pic1" 
							>
							</image-upload>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :xl="8">
						<el-form-item prop="otherPic" label="开户许可证:" :rules="[{required: true, message: '请上传开户许可证'}]" :show-message="formData.otherPic ? false : true">
							<image-upload 
								:url.sync="formData.otherPic" 
								:urlFull.sync="formData.otherPic" 
							>
							</image-upload>
						</el-form-item>
					</el-col>
				</el-row>
            </template>       
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
export default {
    props:{
        formData:{
            type: Object,
            default: null
        },
		type:{
			type:[String,Number], //只有演出新增了注册资本，企业类型等四个字段。这个用来区分是演出，周边还是众筹#52098 加
			default:''
		}
    },
    components:{ImageUpload},
    data(){
        return{}
    },
	created(){
		console.log(this.type)
	}
}
</script>

<style lang="scss" scoped>
.hide-required-asterisk{
    ::v-deep .el-form-item__label{
        &:before{
            content: '' !important;
        }
    }
}
</style>